import { render, staticRenderFns } from "./ProductToInvestRow.vue?vue&type=template&id=a5b5a0fa&scoped=true"
import script from "./ProductToInvestRow.vue?vue&type=script&lang=ts"
export * from "./ProductToInvestRow.vue?vue&type=script&lang=ts"
import style0 from "./ProductToInvestRow.vue?vue&type=style&index=0&id=a5b5a0fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b5a0fa",
  null
  
)

export default component.exports